import React, { useEffect } from 'react';
import { Xmark } from '@gravity-ui/icons';
import { DetectionZonesOverlay } from '../../../components/DetectionZonesOverlay/DetectionZonesOverlay';

/**
 * Полноэкранный просмотр Evidence. Закрывается кнопкой и Escape — на мобильном
 * (PART 3, раздел 8) закрытие должно быть очевидным, а не жестом наугад.
 */
const EvidenceLightbox = ({ url, caption = '', onClose, zones = [], highlightZoneIds = [] }) => {
  useEffect(() => {
    const onKeyDown = (event) => { if (event.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  if (!url) return null;

  return (
    <div className="vio-lightbox" role="dialog" aria-modal="true" aria-label="Фото нарушения" onClick={onClose}>
      <button type="button" className="vio-lightbox-close" onClick={onClose} aria-label="Закрыть">
        <Xmark width={22} height={22} />
      </button>
      <figure className="vio-lightbox-figure" onClick={(event) => event.stopPropagation()}>
        <DetectionZonesOverlay
          imgClassName="vio-lightbox-image"
          src={url}
          alt="Кадр нарушения"
          zones={zones}
          highlightZoneIds={highlightZoneIds}
        />
        {caption && <figcaption className="vio-lightbox-caption">{caption}</figcaption>}
      </figure>
    </div>
  );
};

export default EvidenceLightbox;
